import React, { useEffect, useState } from "react";
import PostLoginFooter from "components/post-login-footer";
import moment from "moment";
import { H2, H3, H4 } from "visual-components/util/texts";
import DocContainer from "./doc-container";

const Title = ({ text, element = "H2", innerEl = "span" }) => {
  const TitleEl = { H2, H3, H4 }[element];

  return (
    <>
      <TitleEl multiline>
        {React.createElement(innerEl, { dangerouslySetInnerHTML: { __html: text } })}
      </TitleEl>
      <br />
    </>
  );
};

const Paragraph = ({ text }) => (
  <>
    <H4 multiline>
      <span dangerouslySetInnerHTML={{ __html: text }} />
    </H4>
    <br />
  </>
);

function TermsOfUse() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    const fetchContent = async () => {
      try {
        setLoading(true);
        const res = await fetch(`/cs-contents/1?status=1`);
        const data = await res.json();
        if (data?.content) {
          const content = data.content;
          setData(content);
        } else {
          setError("Content not found.");
        }
      } catch (err) {
        setError("Failed to load content.");
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);
  return (
    <DocContainer>
      <div className="container">
        <div className="row text-center">
          <br />
          {data.description ? (
            <>
              <Title text={data.title} innerEl="b" />
            </>
          ) : null}
        </div>
        <div className="row">
          {loading ? (
            <Paragraph text="Loading..." />
          ) : error ? (
            <Paragraph text="Page is coming soon..." />
          ) : data ? (
            <>
              <Paragraph
                text={`Effective Date: ${moment(data.updated_at).format("MMMM D, YYYY")}`}
              />
              <div dangerouslySetInnerHTML={{ __html: data.description }} />
            </>
          ) : (
            <Paragraph text="Page is coming soon..." />
          )}
        </div>
      </div>
      <PostLoginFooter />
    </DocContainer>
  );
}
export default TermsOfUse;
